import {store} from "../store";
import {microphoneSlice} from "./microphoneSlice";
import {MicrophonePermissionStatus} from "../types/MicrophonePermissionStatus";

export const microphoneStore = {
  // State modifiers
  setPermissionStatus: (status: MicrophonePermissionStatus) => {
    store.dispatch((microphoneSlice.actions.permissionStatusReducer(status)));
  },

  // Getters
  getPermissionStatus: (): MicrophonePermissionStatus => {
    return microphoneSlice.selectors.permissionStatusSelector(store.getState());
  },
  getIsAvailable: (): boolean => microphoneSlice.selectors.isAvailable(store.getState()),
}
